import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ScrollText } from "lucide-react";
import { SectionHead, EASE } from "./SectionHead";
import { BlurImg } from "./BlurImg";
import { railTrack, railItem, SwipeHint } from "./Rail";

export const Webtoons = ({ index, series }) => (
  <section id="webtoons" data-testid="webtoons-section" className="relative px-5 sm:px-10 lg:px-16 py-16 md:py-24 border-t border-[#F5A524]/15 bg-[#0E0F14]">
    <SectionHead index={index} kicker="WEBTOONS" title={<>Scroll<br /><span className="text-[#F5A524]">Strips</span></>}>
      <p className="max-w-sm text-base text-zinc-300 leading-relaxed">Vertical comics built for the thumb. Pick a series and read it episode by episode.</p>
    </SectionHead>
    <SwipeHint count={series.length} testid="webtoons-swipe-hint" />
    <div className={`${railTrack} md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 md:gap-6`}>
      {series.map((s, i) => (
        <motion.div key={s.id} className={railItem} initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, delay: (i % 3) * 0.08, ease: EASE }}>
          <Link to={`/webtoon/${s.id}`} data-testid={`webtoon-card-${s.id}`} className="group block clip-corner bg-[#F5A524]/25 hover:bg-[#F5A524] p-px transition-colors duration-300">
            <article className="clip-corner bg-[#12131A] overflow-hidden">
              <div className="relative aspect-[3/4] overflow-hidden">
                <BlurImg src={s.cover_url} alt={s.title} imgClassName="object-top group-hover:translate-y-[-6%] group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent" />
                <span className="absolute top-4 left-4 bg-black/75 border border-[#F5A524]/40 px-2 py-1 font-mono text-[11px] tracking-[0.25em] text-[#F5A524] flex items-center gap-2">
                  <ScrollText size={12} /> {String(s.episode_count).padStart(2, "0")} EP
                </span>
              </div>
              <div className="p-5 flex items-end justify-between gap-4">
                <div className="min-w-0">
                  <h3 className="font-display font-black uppercase text-3xl leading-none group-hover:text-[#F5A524] transition-colors">{s.title}</h3>
                  <p className="mt-2 text-sm text-zinc-400 line-clamp-2">{s.description}</p>
                </div>
                <span className="shrink-0 w-11 h-11 grid place-items-center bg-[#F5A524] text-black transition-transform group-hover:rotate-45"><ArrowUpRight size={20} /></span>
              </div>
            </article>
          </Link>
        </motion.div>
      ))}
    </div>
  </section>
);
